import React, { useContext, useEffect, useMemo, useState } from "react";
import Input from "../../../../stories/Input/Input";
import { Tab, Tabs, TextField } from "@mui/material";
import { Button } from "../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Assign from "../../../../images/Assign.svg";
import EyeWhite from "../../../../images/MOMViewIcon.svg";
import Navbar from "../../../common/layout/Navbar";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../utils/Enum.types";
import { Title } from "../../../../stories/Title/Title";
import useUrlParams from "../../../../customHooks/useUrlParams";
import Edit from "../../../../images/Edit.svg";
import {
  CustomModal,
  toInputStandardDate,
} from "../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../styles/CustomModalStyles";
import AttendanceList from "./AttendanceList";

import AttendanceNotMarked from "../../../../images/Attendance Not Marked.svg";
import TotalPresent from "../../../../images/Total Present.svg";
import Nodata from "../../../../images/NoData.svg";
import { AppContext } from "../../../../context/context";
import { GetProjectsForMom } from "../masters/subsidary/junctions/queries/queries";
import { useLazyQuery } from "@apollo/client";
import {
  GetProjectsForMomData,
  GetProjectsForMomVars,
} from "../masters/subsidary/junctions/queries/types";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { GetMomAttCount, getMomByNodeId } from "./queries/query";
import {
  AtsMomMaster,
  GetMomAttCountResult,
  GetMomAttCountVars,
} from "./queries/types";
import { nodeVar } from "../../../../utils/commonQueryTypes";
import { EMPTY_STRING, emptyMessage } from "../../../../utils/constants";

import RightArrow from "../../../../images/ArrowRight.svg";
import MessageModal from "../../../../customComponents/MessageModal";
import { TableHeaderProps, msgType } from "../../../../utils/types";
import { CustomDrawer } from "../../../../styles/CustomDrawerStyles";
import AttendedEmployeesList from "./view/AttendedEmployeesList";
import { TabPanel, a11yProps } from "../../../../styles/Tabs";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
  TOOLTIP_COLORS,
} from "../../../../styles/Variables";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import { GridAlignment, GridColDef } from "@mui/x-data-grid-pro";
import SuppliersAutocomplete from "../purchase/purchaseorder/rfqtopo/components/SuppliersAutocomplete";
import { LdgrQueryType } from "../masters/supplier/queries/types";
import useLabels from "../../../../customHooks/useLabels";
import TableViewImage from "../../../../images/Table.svg";
import CardViewImage from "../../../../images/Card.svg";
import { CustomTooltip } from "../../../../styles/TooltipStyles";
const Projects = () => {
  const navigate = useNavigate();
  const { customer_id } = useUrlParams();
  const [updateAttendace, setUpdateAttendance] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const { momID } = useUrlParams();
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { ledgerLabel } = useLabels();

  const { user_details } = useLoggedInUserDetails();
  const [searchProject, setSearchProject] = useState("");
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const [attendanceDetails, setAttendanceDetails] = useState(false);
  const [supplierId, setSupplierId] = useState("");

  const [getProjectsForMom, { data: projectsData, loading: projectsLoading }] =
    useLazyQuery<GetProjectsForMomData, GetProjectsForMomVars>(
      GetProjectsForMom
    );
  const [GetMom, { data: momData }] = useLazyQuery<
    { node: AtsMomMaster },
    nodeVar
  >(getMomByNodeId);

  const [checkAttMarked, { data: checkAttMarkedStatus }] = useLazyQuery<
    GetMomAttCountResult,
    GetMomAttCountVars
  >(GetMomAttCount);
  useEffect(() => {
    if (customer_id && momID) {
      checkAttMarked({
        variables: {
          customerID: customer_id,
          momID,
          projectID: -1,
          latest: true,
        },
      });
    }
  }, [customer_id, momID, checkAttMarked]);

  useEffect(() => {
    if (customer_id && momID) {
      getProjectsForMom({
        variables: {
          customerID: customer_id,
          empID: user_details.id,
          momID,
          latest: true,
        },
      });
    }
  }, [customer_id, user_details.id, momID, getProjectsForMom]);

  useEffect(() => {
    if (momID) {
      GetMom({
        variables: {
          id: momID,
        },
      });
    }
  }, [customer_id, user_details.id, momID, getProjectsForMom]);

  const projects = useMemo(() => {
    if (projectsData) {
      return projectsData.GetProjectsForMom.filter((res) => {
        return (
          (res.projectName
            .toLocaleLowerCase()
            .includes(searchProject.toLocaleLowerCase()) ||
            searchProject === EMPTY_STRING) &&
          res.vendorName.includes(supplierId)
        );
      });
    } else return [];
  }, [projectsData, searchProject, supplierId]);

  const rows = useMemo(() => {
    return projects
      .filter((item) => item.vendorName.includes(supplierId))
      .map((res, index) => {
        return {
          id: index + 1,
          lastMeeting: `${res.vendorRespCount} / ${res.pmuCount}`,
          ...res,
        };
      });
  }, [projects, supplierId]);

  const dynamicHeaders: TableHeaderProps[] = ProjectList.map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "status") return statusButton(params.row);
      if (header.field === "viewDetails") return viewDetailsButton(params.row);
      if (header.field === "action") return actionButton(params.row);

      return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const statusButton = (res: any) => {
    const filled = res.vendorRespCount === res.pmuCount && res.pmuCount > 0;
    return (
      <>
        {(state.empSubType === empType.PMU ||
          state.empSubType === empType.VENDOR_MANAGER ||
          state.empSubType === empType.JCP) && (
          <span
            className={`project-meetings__block--card--status${
              filled ? "--green" : "--red"
            }`}
          >
            {filled ? "Filled" : "Pending"}
          </span>
        )}
      </>
    );
  };

  const viewDetailsButton = (res: any) => {
    return (
      <>
        <button
          className="project-meetings__block--card--view"
          // disabled={res.pmuCount === 0}
          onClick={() => {
            if (res.momExists) {
              if (res.viewed) {
                navigate(
                  `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/viediscussedmeetingdetails`
                );
              } else {
                navigate(
                  `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/viewmeetingdetails`
                );
              }
            } else {
              setMessage({
                flag: true,
                message: "No meetings found",
                operation: Operation.NONE,
              });
            }
          }}
        >
          View <img src={EyeWhite} alt="" />
        </button>
      </>
    );
  };

  const actionButton = (res: any) => {
    return (
      <>
        {state.empSubType === empType.PMU ? (
          <button
            className={`project-meetings__block--card--${
              res.pmuCount > 0 ? "update" : "plan"
            }`}
            onClick={() => {
              if (res.viewed) {
                navigate(
                  `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/discussedplan`
                );
              } else {
                navigate(
                  `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/notdiscussedplan`
                );
              }
            }}
          >
            {res.pmuCount > 0 ? "Update" : "Fill"} MOM Details{" "}
            <img src={Assign} alt="" />
          </button>
        ) : state.empSubType === empType.VENDOR_MANAGER ? (
          <button
            className={`project-meetings__block--card--${
              res.vendorRespCount > 0 ? "update" : "plan"
            }`}
            onClick={() =>
              navigate(
                `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/respond`
              )
            }
          >
            {res.vendorRespCount > 0 ? "Update Response" : "Respond"}{" "}
            <img src={Assign} alt="" />
          </button>
        ) : null}
      </>
    );
  };

  const [tableView, setTableView] = useState(false);

  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>Projects Minutes of Meeting</Title>
      <div className="project-meetings">
        <div className="row g-0 project-meetings__select">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchProject(e.target.value);
              }}
            />
          </div>

          <div className="col flex-end">
            <div className="project-meetings__switch-view">
              <div
                className={`tab-icon ${!tableView ? "active" : ""}`}
                onClick={() => setTableView(false)}
              >
                {" "}
                <CustomTooltip
                  title="Table View"
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img src={TableViewImage} alt="" />
                </CustomTooltip>
              </div>
              <div
                className={`tab-icon ${tableView ? "active" : ""}`}
                onClick={() => setTableView(true)}
              >
                <CustomTooltip
                  title="Card View"
                  arrow
                  placement="top"
                  slotProps={{
                    tooltip: {
                      sx: {
                        bgcolor: TOOLTIP_COLORS.VARIABLE,
                        "& .MuiTooltip-arrow": {
                          color: TOOLTIP_COLORS.VARIABLE,
                        },
                      },
                    },
                  }}
                >
                  <img src={CardViewImage} alt="" />
                </CustomTooltip>
              </div>
            </div>

            <TextField
              label="Date"
              className="project-meetings__textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              disabled
              value={
                momData ? toInputStandardDate(momData.node.meetingDate) : ""
              }
            />
          </div>
        </div>
        <div className="project-meetings__header row g-0">
          <div className="col">
            {checkAttMarkedStatus &&
            checkAttMarkedStatus.GetMomAttCount.empCount +
              checkAttMarkedStatus.GetMomAttCount.inviteesCount >
              0 ? (
              <div className="project-meetings__header--marked">
                <div
                  className="project-meetings__header--total"
                  onClick={() => setAttendanceDetails(!attendanceDetails)}
                >
                  <div className="project-meetings__header--total--img">
                    <img src={TotalPresent} alt="" />
                    <span>Total Present</span>
                  </div>
                  <b className="font-green">
                    {Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                      Number(checkAttMarkedStatus.GetMomAttCount.inviteesCount)}
                  </b>
                </div>

                {state.empSubType === empType.PMU ? (
                  <div className="project-meetings__header--block green">
                    <span className="font-green">Attendance Marked</span>
                    <button
                      className="project-meetings__header--update"
                      onClick={() => setUpdateAttendance(!updateAttendace)}
                    >
                      Update Attendance <img src={Edit} alt="" />
                    </button>
                  </div>
                ) : null}
              </div>
            ) : (
              <>
                <div className="project-meetings__header--block red">
                  <img src={AttendanceNotMarked} alt="" />
                  <span className="font-red">Attendance Not Marked</span>
                  {state.empSubType === empType.PMU ? (
                    <button
                      className="project-meetings__header--view"
                      onClick={() =>
                        navigate(
                          `/${customer_id}/minutesofmeeting/${momID}/attendance`
                        )
                      }
                    >
                      Mark Attendance <img src={Assign} alt="" />
                    </button>
                  ) : null}
                </div>
              </>
            )}
          </div>
          <div className="project-meetings__header--dropdown col-2">
            <SuppliersAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  setSupplierId(newValue.label);
                } else {
                  setSupplierId("");
                }
              }}
              onKeyDown={() => {}}
              value={state.supplierId}
              label={`${ledgerLabel}`}
              input={{
                itemID: 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: undefined,
              }}
            />
          </div>
        </div>
        <div className="project-meetings__tab-panel">
          {!tableView ? (
            <>
              {[false, true].map((data) => {
                return (
                  <>
                    <div className="project-meetings__tab-panel--header">
                      {data ? "Discussed Projects" : "Not Discussed Projects"}{" "}
                    </div>

                    <StyledDatagrid
                      columns={columns}
                      rows={rows.filter((item) => item.viewed === data)}
                      rowHeight={TABLE_ROW_HEIGHT}
                      disableRowSelectionOnClick
                      hideFooter
                    />
                  </>
                );
              })}
            </>
          ) : (
            <div className="project-meetings__block">
              {projectsData ? (
                <>
                  {[false, true].map((data) => {
                    return (
                      <>
                        <div className="project-meetings__tab-panel--header">
                          {data
                            ? "Discussed Projects"
                            : "Not Discussed Projects"}{" "}
                        </div>
                        <ul className="project-meetings__block--cards">
                          {projectsData
                            ? projects
                                .filter((item) => item.viewed === data)
                                .map((res, index) => {
                                  const filled =
                                    res.vendorRespCount === res.pmuCount &&
                                    res.pmuCount > 0;
                                  return (
                                    <li
                                      key={index + 1}
                                      className="project-meetings__block--card"
                                      onClick={() => {
                                        if (state.empSubType === empType.JCP) {
                                          navigate(
                                            `/${customer_id}/minutesofmeeting/${momID}/project/${res.projectID}/viewmeetingdetails`
                                          );
                                        }
                                      }}
                                    >
                                      <span>{index + 1}.</span>
                                      <div className="project-meetings__block--card-details">
                                        <b
                                          className="ellipsis-text"
                                          title={res.projectName}
                                        >
                                          {res.projectName}
                                        </b>
                                        <div className="project-meetings__block--company">
                                          <span>{res.vendorName}</span>
                                          <img src={RightArrow} alt="" />
                                        </div>

                                        <div className="project-meetings__block--card--last green">
                                          <span> Last Meeting</span>
                                          <div>
                                            {res.vendorRespCount} /{" "}
                                            {res.pmuCount}
                                            {statusButton(res)}
                                            {viewDetailsButton(res)}
                                          </div>
                                        </div>
                                        <div className="project-meetings__block--card--next">
                                          {actionButton(res)}
                                        </div>
                                      </div>
                                      {/* {state.empSubType === empType.PMU ? (
                      <div className="project-meetings__block--card--next">
                        <button
                          className="project-meetings__block--card--plan"
                          onClick={() =>
                            navigate(
                              `/${ customer_id }/minutesofmeeting/${ momID }/project/${ res.projectID }/plan`
                            )
                          }
                        >
                          Fill MOM Details <img src={Assign} alt="" />
                        </button>
                      </div>
                    ) : state.empSubType === empType.VENDOR_MANAGER ? (
                      <div className="project-meetings__block--card--next">

                        <button
                          className="project-meetings__block--card--plan"
                          onClick={() =>
                            navigate(
                              `/${ customer_id }/minutesofmeeting/${ momID }/project/${ res.projectID }/respond`
                            )
                          }
                        >
                          Respond <img src={Assign} alt="" />
                        </button>
                      </div>
                    ) : null} */}
                                    </li>
                                  );
                                })
                            : null}
                        </ul>
                      </>
                    );
                  })}
                </>
              ) : (
                <img src={Nodata} alt="" className="nodata-image" />
              )}
            </div>
          )}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          <div className="col-3 flex-end">
            <div className="overall-total-count">
              Total :{" "}
              <b>{projectsData ? projectsData.GetProjectsForMom.length : 0}</b>
            </div>
          </div>
        </div>{" "}
      </div>

      <CustomModal
        style={ViewModalStyles}
        isOpen={updateAttendace}
        onRequestClose={() => setUpdateAttendance(!updateAttendace)}
        contentComponent={
          <AttendanceList
            pageType={PageFor.MODAL}
            setModalFlag={setUpdateAttendance}
            date={momData ? momData.node.meetingDate : ""}
            latest={true}
          />
        }
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <CustomDrawer
        anchor="right"
        open={attendanceDetails}
        onClose={() => setAttendanceDetails(!attendanceDetails)}
      >
        <AttendedEmployeesList
          setModalFlag={setAttendanceDetails}
          momId={momID!}
          latest={true}
        />
      </CustomDrawer>
    </>
  );
};

export default Projects;

export const ProjectList = [
  {
    headerName: "Sl",
    cellClassName: "number-cell",
    field: "id",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.SLNO,
  },
  {
    headerName: "Project Name",
    field: "projectName",
    headerAlign: HEADER_TEXT_ALIGN,
    flex: FlexForColumns.DESCRIPTION,
  },
  {
    headerName: "Vendor",
    field: "vendorName",
    headerAlign: HEADER_TEXT_ALIGN,
    flex: FlexForColumns.DESCRIPTION,
  },
  {
    headerName: "Last Meeting",
    field: "lastMeeting",
    headerAlign: HEADER_TEXT_ALIGN,
    flex: FlexForColumns.DATE,
    cellClassName: "number-cell",
    align: SLNO_TEXT_ALIGN,
  },
  {
    headerName: "Status",
    field: "status",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.SLNO,
  },
  {
    headerName: "View Details",
    field: "viewDetails",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.DATE,
  },
  {
    headerName: "Action",
    field: "action",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.ACTION_BUTTON,
  },
];
